import { useEffect, useState } from "react";
import { Box, Card, Divider, FormControl, FormControlLabel, Radio, RadioGroup, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useTranslate } from "src/locales";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import ByzNurseDeleteButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseDeleteButton";
import ByzNursePrintButton2 from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNursePrintButton2";
import ByzMuiAddButton from "src/components/core-components/mui/buttons/ByzMuiAddButton";
import ByzMuiSnackBar from "src/components/core-components/mui/ByzMuiSnackBar";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiButton from "src/components/core-components/mui/buttons/ByzMuiButton";
import AddIcon from "@mui/icons-material/Add";
import ByzDocumentsButton from "src/components/core-components/mui/buttons/ByzDocumentsButton";
import { GridColDef } from "@mui/x-data-grid-premium";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import AdverseReactions from "../adverseRows";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import MedicalUnits from "../medicalUnitsRows";
import DocumentsPanel from "../documents-panel";
import OpenComponentDialog from "src/components/shared-components/modal/openComponentModal";
import MedicalPanel from "../medical-units-panel";
import ByzGrdEditButton from "src/components/core-components/mui/buttons-grid/ByzGrdEditButton";
import ByzGrdDeleteButton from "src/components/core-components/mui/buttons-grid/ByzGrdDeleteButton";
import ByzDataGridToolbar from "src/components/core-components/mui/data-grid/toolbar";

//MUZUN;454081;07042025
function AdverseEffectForm() {

    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [selectedRows, setSelectedRows] = useState<{ [key: number]: boolean }>(
        Object.fromEntries(AdverseReactions.map((row) => [row.id, false]))
    );
    const [alertSeverity, setAlertSeverity] = useState<"error" | "success">(
        "success"
    );
    const showAlert = (message: string, severity: "error" | "success") => {
        setAlertMessage(message);
        setAlertSeverity(severity);
        setAlertOpen(true);
    };

    useEffect(() => {
        //medcardService.create('data1',5);
        //medcardService.delete('data2',5);
        //medcardService.save('data3',5);
    }, []);

    const handleSaveMedcard = async () => {
        try {
            //const response = medcardService.save('data',5);
            const response = 'Medcard Kaydedildi';
            console.log("Save API cevabı:", response);
            showAlert(response, "success");
        } catch (error) {
            console.error("Hata:", error);
            showAlert("Medcard kaydedilirken hata oluştu!", "error");
        }
    };

    const handleDeleteMedcard = async () => {
        try {
            //const response = medcardService.delete('data',5);
            const response = 'Medcard Silindi';
            console.log("Delete API cevabı:", response);
            showAlert(response, "success");
        } catch (error) {
            console.error("Hata:", error);
            showAlert("Medcard silinirken hata oluştu!", "error");
        }
    };

    const handleAddMedcard = async () => {
        try {
            const response = "Medcard Eklendi";
            console.log("Delete API cevabı:", response);
            showAlert(response, "success");
        } catch (error) {
            console.error("Hata:", error);
            showAlert("Medcard Eklenirken hata oluştu!", "error");
        }
    };
    const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newSelectedState = Object.fromEntries(
            Object.keys(selectedRows).map((id) => [Number(id), event.target.checked])
        );
        setSelectedRows(newSelectedState);
        console.log("Tüm satırların seçili durumu:", newSelectedState);
    };

    const { t } = useTranslate();

    const adverseColumns: GridColDef[] = [
        {
            field: "selection",
            headerName: "",
            width: 80,
            sortable: false,
            renderHeader: () => (
                <ByzMuiCheckBox
                    checked={Object.values(selectedRows).every(Boolean)}
                    indeterminate={
                        Object.values(selectedRows).some(Boolean) &&
                        !Object.values(selectedRows).every(Boolean)
                    }
                    onChange={handleSelectAll}
                />
            ),
        },
        { field: "date", headerName: t("adverse-effect-form.date"), flex: 1 },
        { field: "registeredUser", headerName: t("createdby"), flex: 1 },
        { field: "adversEffect", headerName: t("adverse-effect-form.adverse-effect"), flex: 1 },
        { field: "startTime", headerName: t("adverse-effect-form.start-date"), flex: 1 },
        { field: "endTime", headerName: t("adverse-effect-form.end-date"), flex: 1 },
        {
            field: "edit",
            headerName: t("adverse-effect-form.edit"),
            flex: 1,
            renderCell: (params) => (
                <ByzGrdEditButton
                    onClick={() => console.log(`Düzenleniyor: ${params.row.documentsName}`)}
                />
            ),
        },
    ];

    const medicalUnitsColumns: GridColDef[] = [
        {
            field: "selection",
            headerName: "",
            width: 80,
            sortable: false,
            renderHeader: () => (
                <ByzMuiCheckBox
                    checked={Object.values(selectedRows).every(Boolean)}
                    indeterminate={
                        Object.values(selectedRows).some(Boolean) &&
                        !Object.values(selectedRows).every(Boolean)
                    }
                    onChange={handleSelectAll}
                />
            ),
        },
        { field: "drugType", headerName: t("adverse-effect-form.drug-type"), flex: 2 },
        { field: "suspectedDrugName", headerName: t("adverse-effect-form.name-of-the-suspected-drug"), flex: 2 },
        { field: "routeofDrug", headerName: t("adverse-effect-form.route-of-administration"), flex: 2 },
        { field: "dailyDose", headerName: t("adverse-effect-form.daily-dose"), flex: 2 },
        { field: "startDate", headerName: t("adverse-effect-form.start-date"), flex: 2 },
        { field: "endDate", headerName: t("adverse-effect-form.end-date"), flex: 2 },
        { field: "indication", headerName: t("adverse-effect-form.Indication"), flex: 2 },
        { field: "nurse", headerName: t("adverse-effect-form.nurse"), flex: 2 },
        {
            field: "edit",
            headerName: t("adverse-effect-form.edit"),
            flex: 1,
            renderCell: (params) => (
                <ByzGrdEditButton
                    onClick={() => console.log(`Düzenleniyor: ${params.row.documentsName}`)}
                />
            ),
        },
        {
            field: "delete",
            headerName: t("adverse-effect-form.delete"),
            flex: 1,
            renderCell: (params) => (
                <ByzGrdDeleteButton
                    onClick={() => console.log(`Düzenleniyor: ${params.row.documentsName}`)}
                />
            ),
        },
    ];

    const [documentsDialogOpen, setDocumentsDialogOpen] = useState(false);
    const [medicalDialogOpen, setMedicalDialogOpen] = useState(false);


    return (
        <>
            <Stack direction="row" spacing={2} alignItems="center" sx={{ padding: "5px", marginBottom: "20px", mt: 5 }}>
                <Stack direction="row" spacing={2} alignItems="center" sx={{ padding: "5px", borderRight: "1px solid #000000", marginBottom: 0, pr: 2 }}>
                    <ByzNurseSaveButton onClick={handleSaveMedcard} />
                    <ByzMuiAddButton onClick={handleAddMedcard} />
                    <ByzNurseDeleteButton onClick={handleDeleteMedcard} />
                    <ByzNursePrintButton2 />
                </Stack>

                <ByzMuiButton
                    variant="outlined"
                    color="primary"
                    onClick={() => setMedicalDialogOpen(true)}
                    icon={<AddIcon />}
                    sx={{
                        width: "235px",
                        height: "36px",
                        backgroundColor: "#63B4FF33",
                        color: '#2979C3',
                        borderColor: '#2979C3',
                    }}
                >
                    {t("buttons.add-medical-product")}
                </ByzMuiButton>

                <ByzDocumentsButton
                    variant="outlined"
                    color="primary"
                    onClick={() => setDocumentsDialogOpen(true)}
                    sx={{
                        width: "200px",
                        height: "36px",
                        backgroundColor: "#63B4FF33",
                        color: '#2979C3',
                        borderColor: '#2979C3',
                    }}
                >
                </ByzDocumentsButton>
            </Stack>
            <Divider sx={{ my: 2, borderColor: 'black', borderWidth: '1px' }} />
            <Box sx={{ padding: '20px', width: '100%' }}>
                <Grid container spacing={2}>
                    <Grid md={12} xs={12} container direction={'column'} spacing={3}>
                        <Box sx={{ width: "100%" }}>
                            <Card sx={{ marginBottom: "5px" }}>
                                <Grid
                                    container
                                    sx={{ borderBottom: "1px solid #E0E0E0" }}
                                >
                                    <Grid md={12} xs={12} sx={{ backgroundColor: 'rgb(231, 239, 252)', borderBottom: '1px solid #E0E0E0', borderRadius: '9px', p: 2 }}>
                                        <ByzMuiTypography isTitle sx={{ color: '#2979C3' }}>
                                            {t("adverse-effect-form.adverse-reactions")}
                                        </ByzMuiTypography>

                                    </Grid>
                                    <Grid md={12} xs={12}>
                                        <ByzMuiDataGrid
                                            customToolbar={ByzDataGridToolbar}
                                            columns={adverseColumns}
                                            pageSize={10}
                                            rows={AdverseReactions}
                                        />
                                    </Grid>
                                </Grid>

                            </Card>
                        </Box>
                        <Box sx={{ width: "100%", marginBottom:"5px"}}>
                            <Card sx={{ marginBottom: "5px" }}>
                                <Grid container sx={{ borderBottom: "1px solid #E0E0E0" }}>
                                    <Grid
                                        xs={12}
                                        sx={{
                                            backgroundColor: "rgb(231, 239, 252)",
                                            borderBottom: "1px solid #E0E0E0",
                                            borderRadius: "9px",
                                            p: 2,
                                        }}
                                    >
                                        <ByzMuiTypography isTitle sx={{ color: "#2979C3" }}>
                                            {t("adverse-effect-form.severity-criterion")}
                                        </ByzMuiTypography>
                                    </Grid>
                                    <Grid xs={12} sx={{ p: 0 }}>
                                        <Grid container spacing={2} alignItems="center">
                                            <Grid xs={12} md={4}>
                                                <FormControlLabel
                                                    value="1"
                                                    control={<Radio />}
                                                    label={t("adverse-effect-form.serious")}
                                                />
                                            </Grid>
                                            <Grid xs={12} md={4}>
                                                <FormControlLabel
                                                    value="0"
                                                    control={<Radio />}
                                                    label={t("adverse-effect-form.life-threatening")}
                                                />
                                            </Grid>
                                            <Grid xs={12} md={4} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Card>
                            <Card sx={{ marginBottom: "5px" }}>
                                <Grid container sx={{ borderBottom: "1px solid #E0E0E0", pt: 2 }}>
                                    <Grid container spacing={2} sx={{ p: 2 }}>
                                        <Grid xs={12} md={4}>
                                            <FormControlLabel
                                                value="1"
                                                control={<Radio />}
                                                label={t("adverse-effect-form.life-threatening")}
                                            />
                                        </Grid>
                                        <Grid xs={12} md={4}>
                                            <FormControlLabel
                                                value="2"
                                                control={<Radio />}
                                                label={t("adverse-effect-form.causing-hospitalization-stay")}
                                            />
                                        </Grid>
                                        <Grid xs={12} md={4}>
                                            <FormControlLabel
                                                value="3"
                                                control={<Radio />}
                                                label={t("adverse-effect-form.causing-permanent-significant-incapacity")}
                                            />
                                        </Grid>
                                        <Grid xs={12} md={4}>
                                            <FormControlLabel
                                                value="4"
                                                control={<Radio />}
                                                label={t("adverse-effect-form.congenital-anomaly-birth-defect")}
                                            />
                                        </Grid>
                                        <Grid xs={12} md={4}>
                                            <FormControlLabel
                                                value="5"
                                                control={<Radio />}
                                                label={t("adverse-effect-form.medically-significant")}
                                            />
                                        </Grid>
                                        <Grid xs={12} md={4}>
                                            <FormControlLabel
                                                value="6"
                                                control={<Radio />}
                                                label={t("adverse-effect-form.death")}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Card>
                            <Card>
                                <Grid container sx={{ borderBottom: "1px solid #E0E0E0", pt: 2, pb: 2 }}>
                                    <Box>
                                        <Grid container direction="column">
                                            <Grid md={12} xs={12} sx={{ mb: 1 }}>
                                                <ByzMuiTypography sx={{ fontSize: '13px' }}>
                                                    {t("adverse-effect-form.date-of-death")}
                                                </ByzMuiTypography>
                                            </Grid>
                                            <Grid md={12} xs={12} sx={{ pl: 2 }}>
                                                <ByzMuiDateTimePicker sx={{
                                                    width: '353px',
                                                    "& .MuiOutlinedInput-root": {
                                                        "& fieldset": {
                                                            borderColor: "#2979C3",
                                                        },
                                                    },
                                                }}
                                                    label={t("adverse-effect-form.date")} />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Box>
                                        <Grid container direction="column">
                                            <Grid md={12} xs={12} sx={{ mb: 1 }}>
                                                <ByzMuiTypography sx={{ fontSize: '13px' }}>
                                                    {t("adverse-effect-form.reason-of-death")}
                                                </ByzMuiTypography>
                                            </Grid>
                                            <Grid md={12} xs={12} sx={{ pl: 2 }}>
                                                <ByzMuiTextField
                                                    variant="outlined"
                                                    multiline
                                                    rows={3}
                                                    sx={{
                                                        width: '353px',
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                borderColor: "#2979C3",
                                                            },
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Box>
                                        <Grid container direction="column">
                                            <Grid md={12} xs={12} sx={{ mb: 1 }}>
                                                <ByzMuiTypography sx={{ fontSize: '13px' }}>
                                                    {t("adverse-effect-form.was-an-autopsy-performed")}
                                                </ByzMuiTypography>
                                            </Grid>
                                            <Grid md={12} xs={12} sx={{ pl: 2 }}>
                                                <RadioGroup
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                    name="row-radio-buttons-group"
                                                    sx={{ gap: 3, p: 2 }}
                                                >
                                                    <Stack direction="row" spacing={2}>
                                                        <FormControlLabel sx={{ pr: 13 }} value="1" control={<Radio />} label={t("adverse-effect-form.yes")} />
                                                        <FormControlLabel sx={{ pr: 7 }} value="2" control={<Radio />} label={t("adverse-effect-form.no")} />
                                                    </Stack>
                                                </RadioGroup>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Box>
                                        <Grid container direction="column">
                                            <Grid md={12} xs={12} sx={{ mb: 1 }}>
                                                <ByzMuiTypography sx={{ fontSize: '13px' }}>
                                                    {t("adverse-effect-form.description")}
                                                </ByzMuiTypography>
                                            </Grid>
                                            <Grid md={12} xs={12} sx={{ pl: 2 }}>
                                                <ByzMuiTextField
                                                    multiline
                                                    rows={3}
                                                    sx={{
                                                        width: '353px',
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                borderColor: "#2979C3",
                                                            },
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                            </Card>
                        </Box>
                        <Box sx={{ width: "100%", marginBottom:"5px"}}>
                            <Card>
                                <Grid
                                    container
                                    sx={{ borderBottom: "1px solid #E0E0E0", pb: 2 }}
                                >
                                    <Grid md={12} xs={12} sx={{ backgroundColor: 'rgb(231, 239, 252)', borderBottom: '1px solid #E0E0E0', borderRadius: '9px', p: 2 }}>
                                        <ByzMuiTypography isTitle sx={{ color: '#2979C3' }}>
                                            {t("adverse-effect-form.result")}
                                        </ByzMuiTypography>
                                    </Grid>
                                    <Box sx={{ pt: 2 }}>
                                        <Grid container direction="column">
                                            <Grid md={12} xs={12} sx={{ mb: 1 }}>
                                                <ByzMuiTypography sx={{ fontSize: '13px' }}>
                                                    {t("adverse-effect-form.result")}
                                                </ByzMuiTypography>
                                            </Grid>
                                            <Grid md={12} xs={12} sx={{ pl: 2 }}>
                                                <ByzMuiSelect
                                                    renderInput={(params) => <ByzMuiTextField {...params} label="label" variant="outlined" />}
                                                    options={[]}
                                                    sx={{
                                                        width: '353px',
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                borderColor: "#2979C3",
                                                            },
                                                        }
                                                    }}
                                                    color="info"
                                                    label={t("open-process-menu.select")}
                                                    placeholder={t("open-process-menu.select")}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Box sx={{ pt: 2 }}>
                                        <Grid container direction="column">
                                            <Grid md={12} xs={12} sx={{ mb: 1 }}>
                                                <ByzMuiTypography sx={{ fontSize: '13px' }}>
                                                    {t("adverse-effect-form.description")}
                                                </ByzMuiTypography>
                                            </Grid>
                                            <Grid md={12} xs={12} sx={{ pl: 2 }}>
                                                <ByzMuiTextField
                                                    multiline
                                                    rows={3}
                                                    sx={{
                                                        width: '353px',
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                borderColor: "#2979C3",
                                                            },
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Box sx={{ pt: 2 }}>
                                        <Grid container direction="column">
                                            <Grid md={12} xs={12} sx={{ mb: 1 }}>
                                                <ByzMuiTypography sx={{ fontSize: '13px' }}>
                                                    {t("adverse-effect-form.laboratory-finding")}
                                                </ByzMuiTypography>
                                            </Grid>
                                            <Grid md={12} xs={12} sx={{ pl: 2 }}>
                                                <ByzMuiTextField
                                                    multiline
                                                    rows={3}
                                                    sx={{
                                                        width: '353px',
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                borderColor: "#2979C3",
                                                            },
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Box sx={{ pt: 2 }}>
                                        <Grid container direction="column">
                                            <Grid md={12} xs={12} sx={{ mb: 1 }}>
                                                <ByzMuiTypography sx={{ fontSize: '13px' }}>
                                                    {t("adverse-effect-form.relevant-medical-history")}
                                                </ByzMuiTypography>
                                            </Grid>
                                            <Grid md={12} xs={12} sx={{ pl: 2 }}>
                                                <ByzMuiTextField
                                                    multiline
                                                    rows={3}
                                                    sx={{
                                                        width: '353px',
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                borderColor: "#2979C3",
                                                            },
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                            </Card>
                        </Box>
                        <Box>
                            <Card sx={{ marginBottom: "5px" }}>
                                <Grid
                                    container
                                    sx={{ borderBottom: "1px solid #E0E0E0" }}
                                >
                                    <Grid md={12} xs={12} sx={{ backgroundColor: 'rgb(231, 239, 252)', borderBottom: '1px solid #E0E0E0', borderRadius: '9px', p: 2 }}>
                                        <ByzMuiTypography isTitle sx={{ color: '#2979C3' }}>
                                            {t("adverse-effect-form.utilized-medical-units")}
                                        </ByzMuiTypography>
                                    </Grid>
                                    <Grid md={12} xs={12}>
                                        <ByzMuiDataGrid
                                            customToolbar={ByzDataGridToolbar}
                                            columns={medicalUnitsColumns}
                                            pageSize={10}
                                            rows={MedicalUnits}
                                        />
                                    </Grid>
                                </Grid>
                            </Card>
                        </Box>
                        <Box>
                            <Card sx={{ marginBottom: "5px", pt: 2 }}>
                                <Grid
                                    container
                                    spacing={2}
                                    sx={{ pb: 2 }}
                                >
                                    <Grid xs={12} md={3}>
                                        <Box sx={{ pl: 1 }}>
                                            <Grid container sx={{ pt: 2 }}>
                                                <Grid xs={12} sx={{ mb: 2 }}>
                                                    <ByzMuiTypography sx={{ fontSize: "13px", pl: 12 }}>
                                                        {t("adverse-effect-form.was-drug-discontinued")}
                                                    </ByzMuiTypography>
                                                </Grid>
                                                <Grid xs={12} sx={{ mb: 1 }}>
                                                    <FormControl>
                                                        <RadioGroup
                                                            row
                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                            name="row-radio-buttons-group"
                                                            sx={{ gap: 5, pl: 2 }}
                                                        >
                                                            <FormControlLabel value="1" control={<Radio />} label={t("adverse-effect-form.yes")} />
                                                            <FormControlLabel value="0" control={<Radio />} label={t("adverse-effect-form.no")} />
                                                            <FormControlLabel value="0" control={<Radio />} label={t("adverse-effect-form.unknown")} />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </Grid>
                                                <Grid xs={12}>
                                                    <ByzMuiTypography sx={{ fontSize: "13px" }}>
                                                        {t("adverse-effect-form.description")}
                                                    </ByzMuiTypography>
                                                </Grid>
                                                <Grid xs={12}>
                                                    <ByzMuiTextField
                                                        multiline
                                                        rows={3}
                                                        sx={{
                                                            width: "345px",
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    borderColor: "#2979C3",
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Grid>
                                    <Grid xs={12} md={3}>
                                        <Box sx={{ pl: 1 }}>
                                            <Grid container direction="column" alignItems="flex-start">
                                                <Grid xs={12} sx={{ mb: 2 }}>
                                                    <ByzMuiTypography sx={{ fontSize: "13px" }}>
                                                        {t("adverse-effect-form.adverse-effect-after-discontinuation-or-dose-reduction")}
                                                    </ByzMuiTypography>
                                                </Grid>
                                                <Grid xs={12} sx={{ mb: 1 }}>
                                                    <FormControl>
                                                        <RadioGroup
                                                            row
                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                            name="row-radio-buttons-group"
                                                            sx={{ gap: 5, pl: 2 }}
                                                        >
                                                            <FormControlLabel value="1" control={<Radio />} label={t("adverse-effect-form.yes")} />
                                                            <FormControlLabel value="0" control={<Radio />} label={t("adverse-effect-form.no")} />
                                                            <FormControlLabel value="0" control={<Radio />} label={t("adverse-effect-form.unknown")} />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </Grid>
                                                <Grid xs={12}>
                                                    <ByzMuiTypography sx={{ fontSize: "13px" }}>
                                                        {t("adverse-effect-form.description")}
                                                    </ByzMuiTypography>
                                                </Grid>
                                                <Grid xs={12}>
                                                    <ByzMuiTextField
                                                        multiline
                                                        rows={3}
                                                        sx={{
                                                            width: "345px",
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    borderColor: "#2979C3",
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Grid>
                                    <Grid xs={12} md={3}>
                                        <Box sx={{ pl: 1 }}>
                                            <Grid container sx={{ pt: 2 }}>
                                                <Grid xs={12} sx={{ mb: 2 }}>
                                                    <ByzMuiTypography sx={{ fontSize: "13px", pl: 9 }}>
                                                        {t("adverse-effect-form.was-drug-readministered")}
                                                    </ByzMuiTypography>
                                                </Grid>
                                                <Grid xs={12} sx={{ mb: 1 }}>
                                                    <FormControl>
                                                        <RadioGroup
                                                            row
                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                            name="row-radio-buttons-group"
                                                            sx={{ gap: 5, pl: 2 }}
                                                        >
                                                            <FormControlLabel value="1" control={<Radio />} label={t("adverse-effect-form.yes")} />
                                                            <FormControlLabel value="0" control={<Radio />} label={t("adverse-effect-form.no")} />
                                                            <FormControlLabel value="0" control={<Radio />} label={t("adverse-effect-form.unknown")} />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </Grid>
                                                <Grid xs={12}>
                                                    <ByzMuiTypography sx={{ fontSize: "13px" }}>
                                                        {t("adverse-effect-form.description")}
                                                    </ByzMuiTypography>
                                                </Grid>
                                                <Grid xs={12}>
                                                    <ByzMuiTextField
                                                        multiline
                                                        rows={3}
                                                        sx={{
                                                            width: "345px",
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    borderColor: "#2979C3",
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Grid>
                                    <Grid xs={12} md={3}>
                                        <Box sx={{ pl: 1 }}>
                                            <Grid container sx={{ pt: 2 }}>
                                                <Grid xs={12} sx={{ mb: 2 }} alignItems="flex-start">
                                                    <ByzMuiTypography sx={{ fontSize: "13px" }}>
                                                        {t("adverse-effect-form.adverse-effect-after-readministration")}
                                                    </ByzMuiTypography>
                                                </Grid>
                                                <Grid xs={12} sx={{ mb: 1 }}>
                                                    <FormControl>
                                                        <RadioGroup
                                                            row
                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                            name="row-radio-buttons-group"
                                                            sx={{ gap: 5, pl: 2 }}
                                                        >
                                                            <FormControlLabel value="1" control={<Radio />} label={t("adverse-effect-form.yes")} />
                                                            <FormControlLabel value="0" control={<Radio />} label={t("adverse-effect-form.no")} />
                                                            <FormControlLabel value="0" control={<Radio />} label={t("adverse-effect-form.unknown")} />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </Grid>
                                                <Grid xs={12}>
                                                    <ByzMuiTypography sx={{ fontSize: "13px" }}>
                                                        {t("adverse-effect-form.description")}
                                                    </ByzMuiTypography>
                                                </Grid>
                                                <Grid xs={12}>
                                                    <ByzMuiTextField
                                                        multiline
                                                        rows={3}
                                                        sx={{
                                                            width: "345px",
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    borderColor: "#2979C3",
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    spacing={2}
                                    sx={{ borderBottom: "1px solid #E0E0E0", pb: 2 }}
                                >
                                    <Grid xs={12} md={3}>
                                        <Box sx={{ pl: 1 }}>
                                            <Grid container sx={{ pt: 2 }}>
                                                <Grid xs={12} sx={{ mb: 2 }} alignItems="flex-start">
                                                    <ByzMuiTypography sx={{ fontSize: "13px", pl: 9 }}>
                                                        {t("adverse-effect-form.other-observations-comments")}
                                                    </ByzMuiTypography>
                                                </Grid>
                                                <Grid xs={12}>
                                                    <ByzMuiTextField
                                                        multiline
                                                        rows={3}
                                                        sx={{
                                                            width: "345px",
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    borderColor: "#2979C3",
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Grid>
                                    <Grid xs={12} md={3}>
                                        <Box sx={{ pl: 1 }}>
                                            <Grid container sx={{ pt: 2 }}>
                                                <Grid xs={12} sx={{ mb: 2 }} alignItems="flex-start">
                                                    <ByzMuiTypography sx={{ fontSize: "13px", pl: 7 }}>
                                                        {t("adverse-effect-form.treatment-adverse-reaction")}
                                                    </ByzMuiTypography>
                                                </Grid>
                                                <Grid xs={12}>
                                                    <ByzMuiTextField
                                                        multiline
                                                        rows={3}
                                                        sx={{
                                                            width: "345px",
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    borderColor: "#2979C3",
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Card>
                        </Box>

                        <ByzMuiSnackBar
                            open={alertOpen}
                            onClose={() => setAlertOpen(false)}
                            title={
                                alertSeverity === "success"
                                    ? t("operation-successful")
                                    : t("error")
                            }
                            message={alertMessage}
                            type={alertSeverity}
                        />
                    </Grid>
                </Grid>
            </Box>

            <Stack mt={5} direction="row" spacing={2}>
                <OpenComponentDialog
                    open={documentsDialogOpen}
                    showAddButton
                    onClose={() => setDocumentsDialogOpen(false)}
                >
                    <DocumentsPanel />
                </OpenComponentDialog>
            </Stack>

            <OpenComponentDialog
                title={t("adverse-effect-form.used-medical-products")}
                open={medicalDialogOpen}
                onClose={() => setMedicalDialogOpen(false)}
                isMedCard
            >
                <MedicalPanel />
            </OpenComponentDialog>
        </>
    );
}

export default AdverseEffectForm;